module.exports = __webpack_public_path__ + "media/images/common/3column_product_bg_nxx-e18e931ffa652af8ce25f227bff5eebb.png";